export interface AwaitableQuery {
  isEnabled?: boolean;
  isError: boolean;
  isFetched: boolean;
  isFetching: boolean;
}

// AIDEV-NOTE: react-query v4's isLoading/isInitialLoading are both unusable here — `placeholderData`
// resolves a query to 'success' so isLoading is false during its first fetch, while `enabled: false`
// pins isLoading true forever. Gate on this instead. See .claude/docs/patterns-frontend.md.
const isAwaitingData = (...queries: AwaitableQuery[]) => queries.some(
  ({ isEnabled = true, isError, isFetched, isFetching }) => (
    isEnabled && !isError && (isFetching || !isFetched)
  ),
);

export default isAwaitingData;
